// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RecentProducts_container__SIFS7 {
  width: 100%;
  max-width: 1140px;
  margin: 0 auto;
  text-align: center;
}

.RecentProducts_title__qI33B {
  font-size: 28px;
  margin-bottom: 20px;
  color: #333;
  font-weight: normal;
}

.RecentProducts_outerContainer__BACi5 {
  display: flex;
  justify-content: center;
  position: relative;
  box-sizing: border-box;
}

.RecentProducts_boxes__cseX1 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  max-width: 1140px;
  width: 100%;
}

.RecentProducts_boxesSpace__I\\+O6t {
  justify-content: space-between;
}

.RecentProducts_box__KSA8y {
  flex: 1 1;
  max-width: calc(25% - 10px);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
  height: 300px; /* Dimensiune fixă pentru uniformizare */
  border: 1px solid #ddd;
  box-sizing: border-box;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 15px;
  text-align: left;
  cursor: pointer;
  text-decoration: none;
}

/* .box:hover {
  transform: scale(1.05);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
} */

.RecentProducts_imageWrapper__Pq3qL {
  width: 100%;
  height: 200px; /* Dimensiune fixă pentru imagini */
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.RecentProducts_image__EHOIZ {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain; /* Redimensionează imaginea păstrând proporțiile */
}

.RecentProducts_name__hJ4Q9 {
  margin-top: 10px;
  font-size: 16px;
  text-align: left; /* Aliniere la stânga */
  color: red; /* Schimbă culoarea în roșu */
  width: 100%; /* Asigură că ocupă întreaga lățime disponibilă */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.RecentProducts_bottomRow__EqAyC {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: auto; /* Asigură poziționarea în partea de jos a box-ului */
}

.RecentProducts_price__Q-5Ge {
  font-size: 16px;
  font-weight: bold;
  color: gray;
}

.RecentProducts_cartButton__DI1-A {
  background-color: #e53935;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  cursor: pointer;
}

.RecentProducts_cartButton__DI1-A:hover {
  background-color: #c62828;
}

.RecentProducts_arrow__s2pR- {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  border-radius: 10px;
  padding: 35px 0px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.RecentProducts_leftArrow__YHyhD {
  left: 10px;
}

.RecentProducts_rightArrow__SoK9v {
  right: 10px;
}

.RecentProducts_arrow__s2pR-:hover {
  background-color: rgba(0, 0, 0, 0.75);
}

@media (max-width: 768px) {
  .RecentProducts_container__SIFS7 {
    margin-top: 20px;
  }

  .RecentProducts_boxes__cseX1 {
    display: flex;
    justify-content: center;
    gap: 0px;
  }

  .RecentProducts_box__KSA8y {
    max-width: calc(100% - 20px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/RecentProducts/RecentProducts.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,aAAa,EAAE,wCAAwC;EACvD,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;;;GAGG;;AAEH;EACE,WAAW;EACX,aAAa,EAAE,mCAAmC;EAClD,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB,EAAE,kDAAkD;AACzE;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB,EAAE,uBAAuB;EACzC,UAAU,EAAE,6BAA6B;EACzC,WAAW,EAAE,iDAAiD;EAC9D,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,gBAAgB,EAAE,qDAAqD;AACzE;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":[".container {\n  width: 100%;\n  max-width: 1140px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.title {\n  font-size: 28px;\n  margin-bottom: 20px;\n  color: #333;\n  font-weight: normal;\n}\n\n.outerContainer {\n  display: flex;\n  justify-content: center;\n  position: relative;\n  box-sizing: border-box;\n}\n\n.boxes {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n  max-width: 1140px;\n  width: 100%;\n}\n\n.boxesSpace {\n  justify-content: space-between;\n}\n\n.box {\n  flex: 1;\n  max-width: calc(25% - 10px);\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 10px;\n  height: 300px; /* Dimensiune fixă pentru uniformizare */\n  border: 1px solid #ddd;\n  box-sizing: border-box;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  padding: 15px;\n  text-align: left;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n/* .box:hover {\n  transform: scale(1.05);\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n} */\n\n.imageWrapper {\n  width: 100%;\n  height: 200px; /* Dimensiune fixă pentru imagini */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n}\n\n.image {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain; /* Redimensionează imaginea păstrând proporțiile */\n}\n\n.name {\n  margin-top: 10px;\n  font-size: 16px;\n  text-align: left; /* Aliniere la stânga */\n  color: red; /* Schimbă culoarea în roșu */\n  width: 100%; /* Asigură că ocupă întreaga lățime disponibilă */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.bottomRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin-top: auto; /* Asigură poziționarea în partea de jos a box-ului */\n}\n\n.price {\n  font-size: 16px;\n  font-weight: bold;\n  color: gray;\n}\n\n.cartButton {\n  background-color: #e53935;\n  color: white;\n  border: none;\n  padding: 10px 15px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.cartButton:hover {\n  background-color: #c62828;\n}\n\n.arrow {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 10;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  padding: 35px 0px;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\n.leftArrow {\n  left: 10px;\n}\n\n.rightArrow {\n  right: 10px;\n}\n\n.arrow:hover {\n  background-color: rgba(0, 0, 0, 0.75);\n}\n\n@media (max-width: 768px) {\n  .container {\n    margin-top: 20px;\n  }\n\n  .boxes {\n    display: flex;\n    justify-content: center;\n    gap: 0px;\n  }\n\n  .box {\n    max-width: calc(100% - 20px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RecentProducts_container__SIFS7`,
	"title": `RecentProducts_title__qI33B`,
	"outerContainer": `RecentProducts_outerContainer__BACi5`,
	"boxes": `RecentProducts_boxes__cseX1`,
	"boxesSpace": `RecentProducts_boxesSpace__I+O6t`,
	"box": `RecentProducts_box__KSA8y`,
	"imageWrapper": `RecentProducts_imageWrapper__Pq3qL`,
	"image": `RecentProducts_image__EHOIZ`,
	"name": `RecentProducts_name__hJ4Q9`,
	"bottomRow": `RecentProducts_bottomRow__EqAyC`,
	"price": `RecentProducts_price__Q-5Ge`,
	"cartButton": `RecentProducts_cartButton__DI1-A`,
	"arrow": `RecentProducts_arrow__s2pR-`,
	"leftArrow": `RecentProducts_leftArrow__YHyhD`,
	"rightArrow": `RecentProducts_rightArrow__SoK9v`
};
export default ___CSS_LOADER_EXPORT___;
